module.exports = __webpack_public_path__ + "static/media/left-bg.1faf3a22.png";